import { CSSProperties, FC } from 'react';
import { Page } from 'react-pdf';
import { Box } from '@mui/system';

import { Spinner } from '../spinner';

export type PdfPageProps = {
    pageViewports: {
        width: number;
        height: number;
    }[];
};

export const PdfPage: FC<
    PdfPageProps & {
        style: CSSProperties;
        index: number;
    }
> = (props) => {
    const { pageViewports, index, style } = props;
    const pageViewport = pageViewports[index];
    const scale = pageViewport.width / pageViewport.width;
    const actualHeight = pageViewport.height * scale;

    return (
        <Box height={actualHeight} style={style}>
            <Page
                pageIndex={index}
                width={pageViewport.width}
                height={actualHeight}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                renderForms={false}
                loading={<Spinner />}
            />
        </Box>
    );
};
